import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Row,
  Col,
} from "reactstrap";
import SocMasterList from "./ReconciliationMasterList";
import { ADDITIONAL_MASTERS, RECONCILIATION_MASTER, SOC_CODE_MASTER } from "../../../config/constants";
import { checkPermission } from "../../../helper";
export const ApplySpecialization = React.createContext();

const ReconciliationListMaster = () => {
  const [state, setState] = useState({
    Id: "",
    // activeTab: "1",
    // isFuelForm: false,
    // isPowerForm: false,
    data: {},
    ViewAccessibility: false,
    AddAccessibility: false,
    EditAccessibility: false,
    DeleteAccessibility: false,
    BulkUploadAccessibility: false,
    DownloadAccessibility: false,
    stopApiCallOnCancel: false,
    permissionData: {},
  });
  // const [permissionData, setPermissionData] = useState({});

  const { leftMenuData, loading, topAndLeftMenuData } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    applyPermission(topAndLeftMenuData);
  }, [topAndLeftMenuData]);

  /**
   * @method applyPermission
   * @description ACCORDING TO PERMISSION HIDE AND SHOW, ACTION'S
   */
  const applyPermission = (topAndLeftMenuData) => {
    
    if (topAndLeftMenuData !== undefined) {
      const Data =
        topAndLeftMenuData &&
        topAndLeftMenuData.find(
          (el) => el.ModuleName === ADDITIONAL_MASTERS
        );
      const accessData =
        Data && Data.Pages.find((el) => el.PageName === RECONCILIATION_MASTER);
      const permmisionDataAccess =
        accessData && accessData.Actions && checkPermission(accessData.Actions);

      if (permmisionDataAccess !== undefined) {
        setState((prevState) => ({
          ...prevState,
          permissionData: permmisionDataAccess,
        }));
      }
    }
  };

  //   /**
  //    * @method toggle
  //    * @description toggling the tabs
  //    */
  //   const toggle = (tab) => {
  //     if (state.activeTab !== tab) {
  //       setState((prevState) => ({ ...prevState, activeTab: tab, stopApiCallOnCancel: false, }));
  //     }
  //   };

  //   const displayFuelForm = () => {
  //     setState((prevState) => ({ ...prevState, isFuelForm: true, isPowerForm: false, data: {}, }));
  //   };

  //   const displayPowerForm = () => {
  //     setState((prevState) => ({ ...prevState, isPowerForm: true, isFuelForm: false, data: {}, }));
  //   };

  const hideForm = (type) => {
    setState((prevState) => ({
      ...prevState,
      isFuelForm: false,
      isPowerForm: false,
      data: {},
      stopApiCallOnCancel: false,
    }));
    if (type === "cancel") {
      setState((prevState) => ({ ...prevState, stopApiCallOnCancel: true }));
    }
  };

  //   const getDetails = (data) => {
  //     setState((prevState) => ({ ...prevState, isFuelForm: true, data: data, }));
  //   };

  //   const getDetailsPower = (data) => {
  //     setState((prevState) => ({ ...prevState, isPowerForm: true, data: data, }));
  //   };

  //   const { isFuelForm, isPowerForm, data } = state;

  //   if (state.isFuelForm === true) {
  //     return <AddFuel data={state.data} hideForm={hideForm} />;
  //   }

  //   if (state.isPowerForm === true) {
  //     return (
  //       <AddPower data={state.data} hideForm={hideForm} stopApiCallOnCancel={state.stopApiCallOnCancel} />
  //     );
  //   }
  return (
    <>
      {state.permissionData && Object.keys(state.permissionData).length > 0 && (
        <div className="container-fluid h-100 hl-cstm-loader-height" id="go-to-top">
          {/* <ScrollToTop pointProp="go-to-top" /> */}
                <ApplySpecialization.Provider
                  value={state.permissionData}
                >
                  <SocMasterList
                    ViewAccessibility={state.ViewAccessibility}
                    AddAccessibility={state.AddAccessibility}
                    EditAccessibility={state.EditAccessibility}
                  />
                </ApplySpecialization.Provider>
        </div>
      )}
    </>
  );
};

export default ReconciliationListMaster;